import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Select from "react-select";
import { Loader, LineChart, BarChart, StackedBarChart } from "../common";
import { convertToCurrencyFormat, isMobileDevice } from "../../helpers/Utils";
import {
  getDashboardData,
  PAYMENT_TYPES,
  lockOrUnlockInstitute,
} from "../../actions";
import StyleConstants from "../../shared/constants/styleConstants/styles.json";
import "./home.css";
import Modal from "react-responsive-modal";
import Pagination from "react-js-pagination";

const customDropdownStyles = {
  control: (base) => ({
    ...base,
    height: 35,
    width: "100%",
    backgroundColor: "white",
    border: "1px solid #CDCFD6",
    fontFamily: "'Poppins', sans-serif",
    borderRadius: 10,
    border: "0px",
    boxShadow: "1px 2px 6px #8b9daf26",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 35,
  }),
  valueContainer: (base) => ({
    ...base,
    height: 35,
    overflow: "auto",
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
    color: state.isFocused ? "#FFF" : "#000",
    backgroundColor: state.isFocused && StyleConstants.color.darkBlue,
    fontFamily: "'Poppins', sans-serif",
  }),
};

const totalRowStyling = {
  borderTop: "1px dashed #c8c8c8",
  color: StyleConstants.color.darkBlue,
};

const IS_MOBILE = isMobileDevice();

class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedCampuses: this.props.campuses,
      hasAccess: true,
      showStudentListModal: false,
      studentIdsList: [],
      page: 1,
      perPage: IS_MOBILE ? 5 : 10,
      showClassroomwiseTagsSpit: false,
    };
  }

  async componentDidMount() {
    await this.props.getDashboardData().then((data) => {
      this.setState({ hasAccess: data.success });
    });
    this.setState({ selectedCampuses: this.props.campuses });
  }

  renderNoFeeAssignedStudentsMessage(studentIdsList) {
    return (
      <div
        style={{
          alignItems: "left",
          marginLeft: IS_MOBILE ? "10px" : "30px",
          borderRadius: 15,
          width: "fit-content",
          background: "rgba(255, 0, 0, 0.2)",
          cursor: "pointer",
        }}
        onClick={() => {
          this.setState({
            studentIdsList: studentIdsList,
            showStudentListModal: true,
          });
        }}
      >
        <div
          style={{
            margin: "1px 5px",
            color: "red",
            fontSize: "14px",
            fontFamily: "'Poppins', sans-serif",
            padding: 4,
          }}
        >
          There are students with no fees assigned to them.
        </div>
      </div>
    );
  }

  renderMultipleSelect(options, selectedOptions, placeholder) {
    return (
      <Select
        value={selectedOptions}
        onChange={(options) => this.setState({ selectedCampuses: options })}
        options={options}
        placeholder={placeholder}
        styles={customDropdownStyles}
        isSearchable
        isClearable
        isMulti
      />
    );
  }

  renderStudentsListModal() {
    const { page, perPage } = this.state;
    const filteredStudentList = this.props.studentsList.filter(
      (student) =>
        this.state.studentIdsList.some((x) => x == student.membership_id) &&
        this.state.selectedCampuses.some((x) => x.value == student.campus_id)
    );
    return (
      <Modal
        center
        styles={{
          modal: {
            width: "80%",
            borderRadius: 10,
          },
        }}
        open={this.state.showStudentListModal}
        onClose={() =>
          this.setState({
            showStudentListModal: false,
            studentIdsList: [],
            page: 1,
          })
        }
      >
        <div
          style={{
            padding: IS_MOBILE ? "25px 0 0 0" : "25px 25px 0 25px",
          }}
        >
          <table
            className="table-new"
            style={{ fontSize: IS_MOBILE && 12, maxWidth: "100%" }}
          >
            <thead>
              <tr>
                {!IS_MOBILE && <th>S.No</th>}
                <th>Name</th>
                <th>Campus</th>
                <th>Classroom</th>
              </tr>
            </thead>
            <tbody>
              {filteredStudentList
                .slice((page - 1) * perPage, page * perPage)
                .map((student, index) => {
                  return (
                    <tr
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        window.open(
                          `/fee_collection?id=${student.membership_id}`
                        )
                      }
                    >
                      {!IS_MOBILE && <td>{(page - 1) * 10 + (index + 1)}</td>}
                      <td>{student.first_name}</td>
                      <td>{student.campus_name}</td>
                      <td>{student.classroom_name}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <Pagination
            activePage={page}
            itemsCountPerPage={perPage}
            totalItemsCount={filteredStudentList.length}
            pageRangeDisplayed={IS_MOBILE ? 2 : 5}
            onChange={(pageNumber) => this.setState({ page: pageNumber })}
          />
        </div>
      </Modal>
    );
  }

  renderInputs() {
    const { campuses } = this.props;
    const { selectedCampuses } = this.state;
    return (
      <div
        style={{
          margin: IS_MOBILE ? "10px" : "10px 30px",
        }}
      >
        {campuses.length > 1 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="title-style">Select Campus</div>
            <div styles={{ width: "100%" }}>
              {this.renderMultipleSelect(
                campuses,
                selectedCampuses,
                IS_MOBILE
                  ? "Type or select campus"
                  : "Type campus name here or select from dropdown"
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }

  renderCampuswiseTable(filteredDashboardData) {
    const { selectedCampuses } = this.state;
    const { dashboardData } = this.props;

    if (IS_MOBILE) {
      return (
        <div style={{ margin: "10px" }}>
          {dashboardData.length > 0 &&
            dashboardData.map((campus) => {
              if (
                selectedCampuses
                  .map((campus) => campus.value)
                  .includes(campus.campus_id)
              ) {
                const listOfNonNilDueStudents = campus.total_students.filter(
                  (x) => !campus.nil_due_students.includes(x)
                );
                const listOfGtFiftyStudents =
                  campus.gt_fifty_percent_due.filter((x) => x !== null);
                return (
                  <div className="card-mobile">
                    <div className="title-style">
                      {
                        selectedCampuses.find(
                          (selectedCampus) =>
                            selectedCampus.value === campus.campus_id
                        ).label
                      }
                    </div>
                    <table className="table-new" style={{ boxShadow: "none" }}>
                      <tbody>
                        <tr>
                          <th style={{ textAlign: "left", padding: 5 }}>
                            Total Students
                          </th>
                          <td
                            style={{
                              padding: 5,
                              textAlign: "right",
                              cursor:
                                campus.total_students.length > 0 && "pointer",
                            }}
                            onClick={() => {
                              campus.total_students.length > 0 &&
                                this.setState({
                                  studentIdsList: campus.total_students,
                                  showStudentListModal: true,
                                });
                            }}
                          >
                            {convertToCurrencyFormat(
                              campus.total_students.length,
                              ""
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "left", padding: 5 }}>
                            # Nil Dues
                          </th>
                          <td
                            style={{
                              padding: 5,
                              textAlign: "right",
                              cursor:
                                campus.nil_due_students.length > 0 && "pointer",
                            }}
                            onClick={() => {
                              campus.nil_due_students.length > 0 &&
                                this.setState({
                                  studentIdsList: campus.nil_due_students,
                                  showStudentListModal: true,
                                });
                            }}
                          >
                            {convertToCurrencyFormat(
                              campus.nil_due_students.length,
                              ""
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "left", padding: 5 }}>
                            # Dues &gt; 0
                          </th>
                          <td
                            style={{
                              padding: 5,
                              textAlign: "right",
                              cursor:
                                listOfNonNilDueStudents.length > 0 && "pointer",
                            }}
                            onClick={() => {
                              listOfNonNilDueStudents.length > 0 &&
                                this.setState({
                                  studentIdsList: listOfNonNilDueStudents,
                                  showStudentListModal: true,
                                });
                            }}
                          >
                            {convertToCurrencyFormat(
                              listOfNonNilDueStudents.length,
                              ""
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "left", padding: 5 }}>
                            # Dues &gt; 50%
                          </th>
                          <td
                            style={{
                              padding: 5,
                              textAlign: "right",
                              cursor:
                                listOfGtFiftyStudents.length > 0 && "pointer",
                            }}
                            onClick={() => {
                              listOfGtFiftyStudents.length > 0 &&
                                this.setState({
                                  studentIdsList: listOfGtFiftyStudents,
                                  showStudentListModal: true,
                                });
                            }}
                          >
                            {convertToCurrencyFormat(
                              listOfGtFiftyStudents.length,
                              ""
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "left", padding: 5 }}>
                            Total Receivables
                          </th>
                          <td style={{ textAlign: "right", padding: 5 }}>
                            {convertToCurrencyFormat(
                              campus.total_receivable_fee
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "left", padding: 5 }}>
                            Collected
                          </th>
                          <td style={{ textAlign: "right", padding: 5 }}>
                            {convertToCurrencyFormat(campus.received_fee)}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "left", padding: 5 }}>
                            Pending
                          </th>
                          <td style={{ textAlign: "right", padding: 5 }}>
                            {campus.total_receivable_fee - campus.received_fee <
                            convertToCurrencyFormat(0)
                              ? 0
                              : convertToCurrencyFormat(
                                  campus.total_receivable_fee -
                                    campus.received_fee
                                )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                );
              }
            })}
        </div>
      );
    }
    return (
      <div style={{ margin: "30px" }}>
        <table className="table-new">
          <thead>
            <tr>
              <th style={{ textAlign: "left" }}>Campus</th>
              <th style={{ textAlign: "right" }}>Total Students</th>
              <th style={{ textAlign: "right" }}># Nil Dues</th>
              <th style={{ textAlign: "right" }}># Dues &gt; 0</th>
              <th style={{ textAlign: "right" }}># Dues &gt; 50%</th>
              <th style={{ textAlign: "right" }}>Total Receivables</th>
              <th style={{ textAlign: "right" }}>Collected</th>
              <th style={{ textAlign: "right" }}>Pending</th>
            </tr>
          </thead>
          <tbody>
            {dashboardData.length > 0 &&
              dashboardData.map((campus) => {
                if (
                  selectedCampuses
                    .map((campus) => campus.value)
                    .includes(campus.campus_id)
                ) {
                  const listOfNonNilDueStudents = campus.total_students.filter(
                    (x) => !campus.nil_due_students.includes(x)
                  );
                  const listOfGtFiftyStudents =
                    campus.gt_fifty_percent_due.filter((x) => x !== null);
                  return (
                    <tr>
                      <td style={{ textAlign: "left" }}>
                        {
                          selectedCampuses.find(
                            (selectedCampus) =>
                              selectedCampus.value === campus.campus_id
                          ).label
                        }
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          cursor: campus.total_students.length > 0 && "pointer",
                        }}
                        onClick={() => {
                          campus.total_students.length > 0 &&
                            this.setState({
                              studentIdsList: campus.total_students,
                              showStudentListModal: true,
                            });
                        }}
                      >
                        {convertToCurrencyFormat(
                          campus.total_students.length,
                          ""
                        )}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          cursor:
                            campus.nil_due_students.length > 0 && "pointer",
                        }}
                        onClick={() => {
                          campus.nil_due_students.length > 0 &&
                            this.setState({
                              studentIdsList: campus.nil_due_students,
                              showStudentListModal: true,
                            });
                        }}
                      >
                        {convertToCurrencyFormat(
                          campus.nil_due_students.length,
                          ""
                        )}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          cursor:
                            listOfNonNilDueStudents.length > 0 && "pointer",
                        }}
                        onClick={() => {
                          listOfNonNilDueStudents.length > 0 &&
                            this.setState({
                              studentIdsList: listOfNonNilDueStudents,
                              showStudentListModal: true,
                            });
                        }}
                      >
                        {convertToCurrencyFormat(
                          listOfNonNilDueStudents.length,
                          ""
                        )}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          cursor: listOfGtFiftyStudents.length > 0 && "pointer",
                        }}
                        onClick={() => {
                          listOfGtFiftyStudents.length > 0 &&
                            this.setState({
                              studentIdsList: listOfGtFiftyStudents,
                              showStudentListModal: true,
                            });
                        }}
                      >
                        {convertToCurrencyFormat(
                          listOfGtFiftyStudents.length,
                          ""
                        )}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {convertToCurrencyFormat(campus.total_receivable_fee)}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {convertToCurrencyFormat(campus.received_fee)}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {campus.total_receivable_fee - campus.received_fee < 0
                          ? convertToCurrencyFormat(0)
                          : convertToCurrencyFormat(
                              campus.total_receivable_fee - campus.received_fee
                            )}
                      </td>
                    </tr>
                  );
                } else {
                  return;
                }
              })}
            <tr>
              <td style={{ textAlign: "left", ...totalRowStyling }}>Total</td>
              <td
                style={{
                  textAlign: "right",
                  cursor:
                    filteredDashboardData.totalStudents.length > 0 && "pointer",
                  ...totalRowStyling,
                }}
                onClick={() => {
                  filteredDashboardData.totalStudents.length > 0 &&
                    this.setState({
                      studentIdsList: filteredDashboardData.totalStudents,
                      showStudentListModal: true,
                    });
                }}
              >
                {convertToCurrencyFormat(
                  filteredDashboardData.totalStudents.length,
                  ""
                )}
              </td>
              <td
                style={{
                  textAlign: "right",
                  cursor:
                    filteredDashboardData.nilDueStudents.length > 0 &&
                    "pointer",
                  ...totalRowStyling,
                }}
                onClick={() => {
                  filteredDashboardData.nilDueStudents.length > 0 &&
                    this.setState({
                      studentIdsList: filteredDashboardData.nilDueStudents,
                      showStudentListModal: true,
                    });
                }}
              >
                {convertToCurrencyFormat(
                  filteredDashboardData.nilDueStudents.length,
                  ""
                )}
              </td>
              <td
                style={{
                  textAlign: "right",
                  cursor:
                    filteredDashboardData.withDueStudents.length > 0 &&
                    "pointer",
                  ...totalRowStyling,
                }}
                onClick={() => {
                  filteredDashboardData.withDueStudents.length > 0 &&
                    this.setState({
                      studentIdsList: filteredDashboardData.withDueStudents,
                      showStudentListModal: true,
                    });
                }}
              >
                {convertToCurrencyFormat(
                  filteredDashboardData.withDueStudents.length,
                  ""
                )}
              </td>
              <td
                style={{
                  textAlign: "right",
                  cursor:
                    filteredDashboardData.gtFiftyPercentDue.length > 0 &&
                    "pointer",
                  ...totalRowStyling,
                }}
                onClick={() => {
                  filteredDashboardData.gtFiftyPercentDue.length > 0 &&
                    this.setState({
                      studentIdsList: filteredDashboardData.gtFiftyPercentDue,
                      showStudentListModal: true,
                    });
                }}
              >
                {convertToCurrencyFormat(
                  filteredDashboardData.gtFiftyPercentDue.length,
                  ""
                )}
              </td>
              <td style={{ textAlign: "right", ...totalRowStyling }}>
                {convertToCurrencyFormat(
                  filteredDashboardData.totalReceivableFee
                )}
              </td>
              <td style={{ textAlign: "right", ...totalRowStyling }}>
                {convertToCurrencyFormat(filteredDashboardData.receivedFee)}
              </td>
              <td style={{ textAlign: "right", ...totalRowStyling }}>
                {filteredDashboardData.unreceivedFee < 0
                  ? convertToCurrencyFormat(0)
                  : convertToCurrencyFormat(
                      filteredDashboardData.unreceivedFee
                    )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderSingleCampusSummary(filteredDashboardData) {
    return (
      <div style={{ borderRadius: 4, margin: IS_MOBILE ? "10px" : "15px" }}>
        <div className="card-row">
          <div
            className="card"
            style={{
              cursor:
                filteredDashboardData.totalStudents.length > 0 && "pointer",
              margin: IS_MOBILE && "5px",
              padding: IS_MOBILE && "10px",
            }}
            onClick={() => {
              filteredDashboardData.totalStudents.length > 0 &&
                this.setState({
                  studentIdsList: filteredDashboardData.totalStudents,
                  showStudentListModal: true,
                });
            }}
          >
            <div className="card-title">Total Students</div>
            <div className="card-content">
              {convertToCurrencyFormat(
                filteredDashboardData.totalStudents.length,
                ""
              )}
            </div>
          </div>
          <div
            className="card"
            style={{
              cursor:
                filteredDashboardData.nilDueStudents.length > 0 && "pointer",
              margin: IS_MOBILE && "5px",
              padding: IS_MOBILE && "10px",
            }}
            onClick={() => {
              filteredDashboardData.nilDueStudents.length > 0 &&
                this.setState({
                  studentIdsList: filteredDashboardData.nilDueStudents,
                  showStudentListModal: true,
                });
            }}
          >
            <div className="card-title"># Nil Dues</div>
            <div className="card-content">
              {convertToCurrencyFormat(
                filteredDashboardData.nilDueStudents.length,
                ""
              )}
            </div>
          </div>
          <div
            className="card"
            style={{
              cursor:
                filteredDashboardData.withDueStudents.length > 0 && "pointer",
              margin: IS_MOBILE && "5px",
              padding: IS_MOBILE && "10px",
            }}
            onClick={() => {
              filteredDashboardData.withDueStudents.length > 0 &&
                this.setState({
                  studentIdsList: filteredDashboardData.withDueStudents,
                  showStudentListModal: true,
                });
            }}
          >
            <div className="card-title"># Dues &gt; 0</div>
            <div className="card-content">
              {convertToCurrencyFormat(
                filteredDashboardData.withDueStudents.length,
                ""
              )}
            </div>
          </div>
          <div
            className="card"
            style={{
              cursor:
                filteredDashboardData.gtFiftyPercentDue.length > 0 && "pointer",
              margin: IS_MOBILE && "5px",
              padding: IS_MOBILE && "10px",
            }}
            onClick={() => {
              filteredDashboardData.gtFiftyPercentDue.length > 0 &&
                this.setState({
                  studentIdsList: filteredDashboardData.gtFiftyPercentDue,
                  showStudentListModal: true,
                });
            }}
          >
            <div className="card-title"># Dues &gt; 50%</div>
            <div className="card-content">
              {convertToCurrencyFormat(
                filteredDashboardData.gtFiftyPercentDue.length,
                ""
              )}
            </div>
          </div>
        </div>
        <div className="card-row">
          <div
            className="card"
            style={{ margin: IS_MOBILE && "5px", padding: IS_MOBILE && "10px" }}
          >
            <div className="card-title">Total Receivables</div>
            <div className="card-content">
              {convertToCurrencyFormat(
                filteredDashboardData.totalReceivableFee
              )}
            </div>
            <div className="card-subtitle"></div>
          </div>
          <div
            className="card"
            style={{ margin: IS_MOBILE && "5px", padding: IS_MOBILE && "10px" }}
          >
            <div className="card-title">Collected</div>
            <div className="card-content">
              {convertToCurrencyFormat(filteredDashboardData.receivedFee)}
            </div>
            <div className="card-subtitle">
              ({filteredDashboardData.receivedFeePercentage || 0}%)
            </div>
          </div>
          <div
            className="card"
            style={{ margin: IS_MOBILE && "5px", padding: IS_MOBILE && "10px" }}
          >
            <div className="card-title">Pending</div>
            <div className="card-content">
              {filteredDashboardData.unreceivedFee < 0
                ? convertToCurrencyFormat(0)
                : convertToCurrencyFormat(filteredDashboardData.unreceivedFee)}
            </div>
            <div className="card-subtitle">
              ({filteredDashboardData.unreceivedFeePercentage || 0}%)
            </div>
          </div>
        </div>
      </div>
    );
  }

  formatTagsData() {
    const { tagsData } = this.props;
    let newTagsData = tagsData.map((tagGroup) => {
      let newTagsList = JSON.parse(tagGroup.tags_list);
      newTagsList = newTagsList.map((tag) => {
        if (
          tag.tag_members_list.length === 1 &&
          tag.tag_members_list[0].id === null
        ) {
          return { ...tag, tag_members_list: [] };
        }
        return tag;
      });
      return { ...tagGroup, tags_list: newTagsList };
    });
    return newTagsData;
  }

  renderCampuswiseTagsDataTable() {
    const { selectedCampuses } = this.state;
    let campusOrder = [];
    const formattedTagsData = this.formatTagsData();
    return (
      <>
        {formattedTagsData.map((tagGroup, idx) => {
          let campusWiseTotal = selectedCampuses.map((campus) => {
            return 0;
          });
          return (
            <div
              style={{ maxWidth: "100%", overflowX: "scroll", marginTop: 10 }}
            >
              <div style={{ margin: "0 30px 30px 30px", maxWidth: "100%" }}>
                <div className="title-style">
                  {tagGroup.tag_group_name || "Standalone Tags"}
                </div>
                <table className="table-new">
                  <thead>
                    <tr>
                      <th style={{ borderRight: "1px dashed #c8c8c8" }}>
                        Tags
                      </th>
                      {selectedCampuses.map((campus) => {
                        idx === 0 && campusOrder.push(campus.value);
                        return (
                          <th style={{ textAlign: "right" }}>{campus.label}</th>
                        );
                      })}
                      <th style={{ borderLeft: "1px dashed #c8c8c8" }}>
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tagGroup.tags_list.map((tag) => {
                      let members_list_count = [];
                      campusOrder.map((campus) => {
                        let count = tag.tag_members_list.filter(
                          (member) => parseInt(member.campus_id, 10) === campus
                        ).length;
                        members_list_count.push(count);
                        campusWiseTotal[campusOrder.indexOf(campus)] += count;
                      });
                      return (
                        <tr>
                          <td style={{ borderRight: "1px dashed #c8c8c8" }}>
                            {tag.tag_name}
                          </td>
                          {members_list_count.map((count) => {
                            return (
                              <td style={{ textAlign: "right" }}>{count}</td>
                            );
                          })}
                          <td
                            style={{
                              fontWeight: "bold",
                              textAlign: "right",
                              borderLeft: "1px dashed #c8c8c8",
                            }}
                          >
                            {members_list_count.reduce(
                              (partialSum, a) => partialSum + a,
                              0
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td
                        style={{
                          border: "1px dashed #c8c8c8",
                          borderLeft: "none",
                          borderBottom: "none",
                        }}
                      >
                        Total
                      </td>
                      {campusWiseTotal.map((campus) => {
                        return (
                          <td
                            style={{
                              borderTop: "1px dashed #c8c8c8",
                              textAlign: "right",
                            }}
                          >
                            {campus}
                          </td>
                        );
                      })}
                      <td
                        style={{
                          fontWeight: "bold",
                          textAlign: "right",
                          border: "1px dashed #c8c8c8",
                          borderRight: "none",
                          borderBottom: "none",
                        }}
                      >
                        {campusWiseTotal.reduce(
                          (partialSum, a) => partialSum + a,
                          0
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}
      </>
    );
  }

  renderClassroomwiseTagsDataTable() {
    const { selectedCampuses } = this.state;
    const { classrooms } = this.props;
    const selectedCampusIds = selectedCampuses.map((campus) => {
      return campus.value;
    });
    let classroomsOrder = [];
    let filteredClassrooms = classrooms.filter((classroom) =>
      selectedCampusIds.includes(classroom.campus_id)
    );
    const formattedTagsData = this.formatTagsData();
    return (
      <>
        {formattedTagsData.map((tagGroup, idx) => {
          let classroomwiseTotal = filteredClassrooms.map((classroom) => {
            return 0;
          });
          return (
            <>
              <div
                className="title-style"
                style={{ marginLeft: 30, marginTop: 10 }}
              >
                {tagGroup.tag_group_name || "Standalone Tags"}
              </div>
              <div style={{ maxWidth: "100%", overflowX: "scroll" }}>
                <div style={{ margin: "0 30px 30px 30px", width: "100%" }}>
                  <table className="table-new">
                    <thead>
                      <tr>
                        <th style={{ borderRight: "1px dashed #c8c8c8" }}>
                          Tags
                        </th>
                        {filteredClassrooms.map((classroom) => {
                          idx === 0 && classroomsOrder.push(classroom.value);
                          return (
                            <th style={{ textAlign: "right" }}>
                              {classroom.label}
                            </th>
                          );
                        })}
                        <th style={{ borderLeft: "1px dashed #c8c8c8" }}>
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {tagGroup.tags_list.map((tag) => {
                        let members_list_count = [];
                        classroomsOrder.map((classroom) => {
                          let count = tag.tag_members_list.filter(
                            (member) =>
                              parseInt(member.classroom_id, 10) === classroom
                          ).length;
                          members_list_count.push(count);
                          classroomwiseTotal[
                            classroomsOrder.indexOf(classroom)
                          ] += count;
                        });
                        return (
                          <tr>
                            <td style={{ borderRight: "1px dashed #c8c8c8" }}>
                              {tag.tag_name}
                            </td>
                            {members_list_count.map((count) => {
                              return (
                                <td style={{ textAlign: "right" }}>{count}</td>
                              );
                            })}
                            <td
                              style={{
                                fontWeight: "bold",
                                textAlign: "right",
                                borderLeft: "1px dashed #c8c8c8",
                              }}
                            >
                              {members_list_count.reduce(
                                (partialSum, a) => partialSum + a,
                                0
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td
                          style={{
                            border: "1px dashed #c8c8c8",
                            borderLeft: "none",
                            borderBottom: "none",
                          }}
                        >
                          Total
                        </td>
                        {classroomwiseTotal.map((classroom) => {
                          return (
                            <td
                              style={{
                                borderTop: "1px dashed #c8c8c8",
                                textAlign: "right",
                              }}
                            >
                              {classroom}
                            </td>
                          );
                        })}
                        <td
                          style={{
                            fontWeight: "bold",
                            textAlign: "right",
                            border: "1px dashed #c8c8c8",
                            borderRight: "none",
                            borderBottom: "none",
                          }}
                        >
                          {classroomwiseTotal.reduce(
                            (partialSum, a) => partialSum + a,
                            0
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          );
        })}
      </>
    );
  }

  renderTagsDataTable() {
    const { showClassroomwiseTagsSpit } = this.state;
    const { campuses } = this.props;
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: IS_MOBILE ? "0 10px" : "0 30px",
          }}
        >
          <div className="title-style">Tag Groups</div>
          {campuses.length > 1 ? (
            <div
              className="Button Primary-Button"
              onClick={() => {
                this.setState({
                  showClassroomwiseTagsSpit: !showClassroomwiseTagsSpit,
                });
              }}
            >
              {showClassroomwiseTagsSpit
                ? "Campus wise split"
                : "Classroom wise split"}
            </div>
          ) : (
            this.setState({
              showClassroomwiseTagsSpit: true,
            })
          )}
        </div>
        {showClassroomwiseTagsSpit
          ? this.renderClassroomwiseTagsDataTable()
          : this.renderCampuswiseTagsDataTable()}
      </>
    );
  }

  renderCollectedFeesBreakupTable(filteredDashboardData) {
    return (
      <>
        <div
          className="title-style"
          style={{ marginLeft: IS_MOBILE ? 10 : 30 }}
        >
          Payments by Type
        </div>
        <div
          style={{
            width: !IS_MOBILE && "40%",
            margin: IS_MOBILE ? "0 10px 10px 10px" : "0 0 30px 30px",
          }}
        >
          <table className="table-new">
            <thead>
              <th style={{ textAlign: "left" }}>Payment Mode</th>
              <th style={{ textAlign: "right" }}>Amount</th>
            </thead>
            <tbody>
              {Object.keys(PAYMENT_TYPES).map((type) => {
                return (
                  <tr>
                    <td style={{ textAlign: "left" }}>{type}</td>
                    <td style={{ textAlign: "right" }}>
                      {convertToCurrencyFormat(
                        filteredDashboardData.collectedFeesSplitup[type] || 0
                      )}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td style={{ textAlign: "left", ...totalRowStyling }}>Total</td>
                <td style={{ textAlign: "right", ...totalRowStyling }}>
                  {convertToCurrencyFormat(filteredDashboardData.receivedFee)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  }

  renderBody() {
    const { selectedCampuses } = this.state;
    const {
      dashboardData,
      campuses,
      monthly_payment_data,
      feesForClassrooms,
      paymentsForClassrooms,
      isAdmin,
      isLocked,
      tagsData,
      isFinanceAdmin,
    } = this.props;

    let filteredDashboardData = {
      totalStudents: [],
      nilDueStudents: [],
      withDueStudents: [],
      totalReceivableFee: 0,
      receivedFee: 0,
      unreceivedFee: 0,
      receivedFeePercentage: 0,
      unreceivedFeePercentage: 0,
      collectedFeesSplitup: {},
      noFeeAssignedStudents: [],
      datewiseFeeCollection: {},
      gtFiftyPercentDue: [],
    };

    const totalFeesAndPayments =
      feesForClassrooms &&
      feesForClassrooms.map((fee) => ({
        ...fee,
        ...paymentsForClassrooms.find(
          (payment) => payment.classroom_id === fee.classroom_id
        ),
      }));

    dashboardData.length > 0 &&
      dashboardData.map((campus) => {
        if (
          selectedCampuses
            .map((campus) => campus.value)
            .includes(campus.campus_id)
        ) {
          filteredDashboardData.totalStudents.push(...campus.total_students);
          filteredDashboardData.nilDueStudents.push(...campus.nil_due_students);
          filteredDashboardData.totalReceivableFee +=
            campus.total_receivable_fee;
          filteredDashboardData.receivedFee += campus.received_fee;
          filteredDashboardData.gtFiftyPercentDue.push(
            ...campus.gt_fifty_percent_due.filter((x) => x !== null)
          );
          Object.keys(campus.collected_fees_splitup).map((type) => {
            if (!filteredDashboardData.collectedFeesSplitup[type])
              filteredDashboardData.collectedFeesSplitup[type] = 0;
            filteredDashboardData.collectedFeesSplitup[type] +=
              campus.collected_fees_splitup[type];
          });
          for (const [date, amount] of Object.entries(
            campus.datewise_fee_collection
          )) {
            if (!filteredDashboardData.datewiseFeeCollection[date]) {
              filteredDashboardData.datewiseFeeCollection[date] = 0;
            }
            filteredDashboardData.datewiseFeeCollection[date] += amount;
          }
          if (campus.no_fee_assigned_students.length > 0) {
            filteredDashboardData.noFeeAssignedStudents.push(
              ...campus.no_fee_assigned_students
            );
          }
        }
      });

    filteredDashboardData.withDueStudents =
      filteredDashboardData.totalStudents.filter(
        (x) => !filteredDashboardData.nilDueStudents.includes(x)
      );

    filteredDashboardData.unreceivedFee =
      filteredDashboardData.totalReceivableFee -
      filteredDashboardData.receivedFee;

    filteredDashboardData.receivedFeePercentage = (
      (filteredDashboardData.receivedFee /
        filteredDashboardData.totalReceivableFee) *
        100 || 0
    ).toFixed(1);

    filteredDashboardData.unreceivedFeePercentage = (
      (filteredDashboardData.unreceivedFee /
        filteredDashboardData.totalReceivableFee) *
        100 || 0
    ).toFixed(1);

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: IS_MOBILE ? "5px" : "15px",
        }}
      >
        {(isFinanceAdmin || isAdmin) && (
          <div
            style={{ alignSelf: "flex-end", width: 150 }}
            className="Button Secondary-Button"
            onClick={() => this.props.lockOrUnlockInstitute()}
          >
            {isLocked ? "Unlock Account" : "Lock Account"}
          </div>
        )}
        {this.renderInputs()}
        {filteredDashboardData.noFeeAssignedStudents.length > 0 &&
          this.renderNoFeeAssignedStudentsMessage([
            ...new Set(filteredDashboardData.noFeeAssignedStudents),
          ])}
        {selectedCampuses.length === 0 ? (
          <div
            style={{
              fontSize: 23,
              fontFamily: "'Poppins', sans-serif",
              color: StyleConstants.color.darkBlue,
              margin: "auto",
              padding: IS_MOBILE ? "30px 10px" : "30px",
              textAlign: "center",
            }}
          >
            {campuses.length === 0
              ? "To get started, please add your students' info"
              : "No Campus Selected"}
          </div>
        ) : (
          <>
            {campuses.length > 1
              ? this.renderCampuswiseTable(filteredDashboardData)
              : this.renderSingleCampusSummary(filteredDashboardData)}
            <div
              style={{ margin: IS_MOBILE ? "0 10px" : "0 30px" }}
              key={filteredDashboardData}
            >
              <div className="title-style">Fee Collected Per Day</div>
              <LineChart
                rawGraphData={filteredDashboardData.datewiseFeeCollection}
                xAxisLabel="Time Period"
                yAxisLabel="Amount Collected"
              />
            </div>
            <div style={{ margin: IS_MOBILE ? "0 10px" : "0 30px" }}>
              {campuses.length > 1 && selectedCampuses.length > 1 ? (
                <StackedBarChart
                  rawGraphData={dashboardData}
                  xAxisLabels={selectedCampuses}
                  multiCampuses
                ></StackedBarChart>
              ) : (
                <StackedBarChart
                  rawGraphData={totalFeesAndPayments}
                  campus={selectedCampuses}
                ></StackedBarChart>
              )}
            </div>
            {tagsData && tagsData.length > 0 && this.renderTagsDataTable()}
            {this.renderCollectedFeesBreakupTable(filteredDashboardData)}
          </>
        )}
      </div>
    );
  }

  noPermission() {
    return (
      <div
        style={{
          paddingTop: 300,
          paddingLeft: 300,
          width: "100%",
          backgroundColor: "#F5F8FA",
          fontSize: "20px",
        }}
      >
        <span style={{ borderStyle: "solid", padding: "10px" }}>
          {this.props.isLocked
            ? "Your Account has been locked."
            : "You dont have permission to access Dashboard"}
        </span>
      </div>
    );
  }

  render() {
    const { isLoading } = this.props;
    const { hasAccess } = this.state;
    if (isLoading) {
      return <Loader />;
    }
    return (
      <div>
        {this.renderStudentsListModal()}
        {hasAccess ? this.renderBody() : this.noPermission()}
      </div>
    );
  }
}

Home.propTypes = {
  isLoading: PropTypes.bool,
  campuses: PropTypes.array,
  dashboardData: PropTypes.array,
};

Home.defaultProps = {
  isLoading: false,
  campuses: [],
  dashboardData: [],
};

const mapStateToProps = ({ home }) => ({
  isLoading: home.isLoading,
  campuses: home.campuses,
  dashboardData: home.dashboardData,
  studentsList: home.studentsList,
  monthly_payment_data: home.monthly_payment_data,
  feesForClassrooms: home.feesForClassrooms,
  paymentsForClassrooms: home.paymentsForClassrooms,
  isAdmin: home.isAdmin,
  isLocked: home.isLocked,
  tagsData: home.tagsData,
  classrooms: home.classrooms,
  isFinanceAdmin: home.isFinanceAdmin,
});

export default withRouter(
  connect(mapStateToProps, { getDashboardData, lockOrUnlockInstitute })(Home)
);
